import { Pipe, PipeTransform } from '@angular/core';
import { MmTranslateService } from './translate.service';

@Pipe({
  name: 'localize'
})
export class LocalizePipe implements PipeTransform {

  constructor(private translateService: MmTranslateService) {

  }
  transform(value: any, ...args: unknown[]): string {
    if (!value) return value;

    if (typeof value === "string") return value;
    return value[this.translateService.currentLang];
  }

}
